/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const SEC = 1000;
const MIN = 60 * SEC;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

const rounded = (nr) => {
	const intNr = Math.trunc(nr);
	const fraction = nr - intNr;
	if (fraction > 0) return nr.toFixed(2);
	return intNr;
};

export const intervalAsString = (ms = 0) => {
	if (ms < 1) return 'n.d.';
	if (ms < SEC) return `${ms} ms`;
	if (ms < MIN) return `${rounded(ms / SEC)} sec`;
	if (ms < HOUR) return `${rounded(ms / MIN)} min`;
	if (ms < DAY) return `${rounded(ms / HOUR)} hours`;
	return `${rounded(ms / DAY)} days`;
};

export const formatDateString = (s = '') => {
	if (!Number.isNaN(Date.parse(s))) {
		const d = new Date(s);
		return `${d.toLocaleDateString()}:${d.toLocaleTimeString()}`;
	}
	return '';
};
